// No imports: the canonical-tag and structured-data modules both need these and import each other.

// Declared on every public page whatever host served it, so duplicate hosts consolidate in search.
export const CANONICAL_ORIGIN = "https://assisted-care.com";

// Canonical home of the PEOPLE arm (served at the root here, `/v2` elsewhere; see host-rewrite.ts).
// The apex, never www.
export const PEOPLE_ORIGIN = "https://ppl-ai.com";

// The auth server trusts only origins it was told about, and every deployment carries this one, so
// doors opened on other hosts point here.
export const PRODUCT_ORIGIN = "https://app.ppl-ai.com";
